import { makeStyles, Tooltip, Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import InfoIcon from '@material-ui/icons/Info'
import abbreviate from 'abbreviate-name'
import {
  DatePicker,
  Filter,
  List,
  TextField,
  useFilter,
  useListRepository
} from 'elentari'
import moment from 'moment'
import React, { useEffect } from 'react'
import { Field } from 'react-final-form'
import { CustomAutocomplete } from '../../components'
import { getListActions } from '../../lib/crudAuthorization'
import { formatSolicitacaoFilterInitialValues } from '../../utils/Formatter'
import { solicitacoesStatusOptions } from '../../utils/Options'
import { parseCpf } from '../../utils/Parse'
import MercadoriaAutocomplete from '../Mercadorias/MercadoriaAutocomplete'
import { BadgeStatus } from '../Solicitacoes/components'
import { useAbility } from '../Usuarios'
import UsuarioAutocomplete from '../Usuarios/UsuarioAutocomplete'
import solicitacoesEmbarcadorRepository from './solicitacoesEmbarcadorRepository'

const useStyles = makeStyles(() => ({
  info: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}))

const SolicitacoesEmbarcadorFilter = () => {
  const classes = useStyles()
  const { onClear, onSubmit, initialValues } = useFilter({})

  const detailedFilter = () => (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Criação"
          name="createdAt"
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Término"
          name="dataTermino"
        />
      </Grid>
    </Grid>
  )

  return (
    <Filter
      onClear={onClear}
      onSubmit={onSubmit}
      detailedFilter={detailedFilter()}
      initialValues={formatSolicitacaoFilterInitialValues(initialValues)}
      labels={{
        detailedFilter: 'Busca avançada',
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid className={classes.info} item xs={12}>
          <Typography variant="h6">Filtros</Typography>
          <Tooltip title="Os filtros irão considerar registros dos últimos 7 dias">
            <InfoIcon />
          </Tooltip>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Field
            fullWidth
            name="motorista"
            label="Motorista"
            component={TextField}
          />
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Field
            fullWidth
            name="cpf"
            label="CPF Motorista"
            parse={parseCpf}
            component={TextField}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="mercadoriaId"
            label="Mercadoria"
            component={MercadoriaAutocomplete}
          />
        </Grid>
        <Grid item md={2} xs={12}>
          <Field fullWidth name="placa" label="Placa" component={TextField} />
        </Grid>
        <Grid item md={2} xs={12}>
          <Field
            fullWidth
            options={solicitacoesStatusOptions}
            name="status"
            label="Status"
            component={CustomAutocomplete}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="responsavelId"
            label="Responsável"
            component={UsuarioAutocomplete}
            realm="analistaadmin"
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="nomeEmbarcador"
            label="Embarcador"
            component={TextField}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const SolicitacoesEmbarcador = props => {
  const [ability] = useAbility()

  const listHook = useListRepository({
    repository: solicitacoesEmbarcadorRepository,
    path: 'solicitacoesEmbarcador'
  })

  useEffect(() => {
    const interval = setInterval(() => listHook.fetchList(), 1000 * 30)
    return () => clearInterval(interval)
  }, [listHook])

  const listOptions = {
    fields: {
      id: {
        label: 'Id'
      },
      motorista: {
        label: 'Motorista',
        format: motorista => (motorista ? abbreviate(motorista.nome) : '-'),
        noOrder: true
      },
      createdAt: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm')
      },
      status: {
        label: 'Status',
        format: (value, solicitacao) => (
          <BadgeStatus
            status={value}
            fonteLiberacao={solicitacao.fonteLiberacao}
            cenario={solicitacao.cenario}
          />
        )
      },
      dataTermino: {
        label: 'Data Término',
        format: data => (data ? moment(data).format('DD/MM/YYYY HH:mm') : '-')
      },
      mercadoria: {
        label: 'Mercadoria',
        format: mercadoria => (mercadoria ? mercadoria.descricao : '-'),
        noOrder: true
      },
      nomeEmbarcador: {
        label: 'Embarcador',
        format: value => (value ? abbreviate(value) : ''),
        noOrder: true
      },
      centroCusto: {
        label: 'Centro de Custo',
        format: centroCusto => (centroCusto ? centroCusto.descricao : '-'),
        noOrder: true
      },
      responsavel: {
        label: 'Responsável',
        format: responsavel => (responsavel ? responsavel.usuario : '-'),
        noOrder: true
      }
    }
  }

  const actions = getListActions(ability, listHook, 'solicitacoesEmbarcador')

  return (
    <>
      <SolicitacoesEmbarcadorFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickEdit={null}
        onClickRow={item =>
          props.history.push(`/solicitacoesEmbarcador/${item.id}`)
        }
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default SolicitacoesEmbarcador
